// API endpoint catalog (US-883 · R-1) — the single client-side source of DRF
// routes, mirrored 1:1 from backend/map_backend/urls.py. Feature hooks compose
// useApi + this catalog; no component or hook hardcodes route strings or hosts
// (AGENTS.md §3/§4). The base URL stays in REACT_APP_API_BASE_URL (useApi).
//
// `reportStatus` is a template: the 202 response of `countryDataRange` already
// delivers the concrete `status_url` (async contract: sdd/specs/US-891/
// contract.md), so consumers normally use that URL directly.
const endpoints = {
  login: { path: "/auth/login/", method: "POST" },
  countryDataRange: { path: "/country-data-range/", method: "POST" },
  reportStatus: { path: "/reports/{task_id}/status/", method: "GET" },
  optimalTechMix: { path: "/optimal-tech-mix/", method: "POST" },
  populationDensityThreshold: { path: "/population-density-threshold/", method: "POST" },
  uncoveredFixedPopDensity: { path: "/uncovered-fixed-pop-density/", method: "POST" },
  uncoveredMobilePopDensity: { path: "/uncovered-mobile-pop-density/", method: "POST" },
};

// Maps a concrete request back to its catalog key, or null when no entry
// matches. Template params ({task_id}) match any non-empty path segment.
// Used by the fixtures layer (US-883 · R-7) to resolve responders.
export const matchEndpoint = (method, path) => {
  const requested = (method || "GET").toUpperCase();
  const match = Object.entries(endpoints).find(([, endpoint]) => {
    if (endpoint.method !== requested) return false;
    const pattern = endpoint.path
      .split(/(\{[^}]+\})/)
      .map((part) =>
        part.startsWith("{") ? "[^/]+" : part.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
      )
      .join("");
    return new RegExp(`^${pattern}$`).test(path);
  });
  return match ? match[0] : null;
};

export default endpoints;
